// Generated from the Rust smart block contracts. Do not edit.

export const AgentChecklistBlockConfigSchema = {
  additionalProperties: false,
  properties: {
    items: {
      items: {
        pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
        type: 'string',
      },
      type: 'array',
    },
    title: {
      nullable: true,
      pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
      type: 'string',
    },
  },
  required: ['items'],
  title: 'AgentChecklistBlockConfig',
  type: 'object',
} as const;

export const AgentProcedureBlockConfigSchema = {
  additionalProperties: false,
  properties: {
    steps: {
      items: {
        pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
        type: 'string',
      },
      type: 'array',
    },
    title: {
      nullable: true,
      pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
      type: 'string',
    },
  },
  required: ['steps'],
  title: 'AgentProcedureBlockConfig',
  type: 'object',
} as const;

export const ImageComparisonBlockConfigSchema = {
  additionalProperties: false,
  properties: {
    images: {
      items: {
        additionalProperties: false,
        properties: {
          documentIdentifier: {
            pattern: '^document\\.[A-Za-z0-9_-]+(?:\\.[A-Za-z0-9_-]+)*:[0-9]+$',
            type: 'string',
          },
          fields: {
            items: {
              additionalProperties: false,
              properties: {
                key: {
                  pattern:
                    '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
                  type: 'string',
                },
                value: {
                  oneOf: [
                    {
                      additionalProperties: false,
                      properties: {
                        color: {
                          enum: ['neutral', 'success', 'warning', 'error', 'info', null],
                          nullable: true,
                          type: 'string',
                        },
                        type: {
                          enum: ['text'],
                          type: 'string',
                        },
                        value: {
                          nullable: true,
                          type: 'string',
                        },
                      },
                      required: ['type', 'value'],
                      type: 'object',
                    },
                    {
                      additionalProperties: false,
                      properties: {
                        color: {
                          enum: ['neutral', 'success', 'warning', 'error', 'info', null],
                          nullable: true,
                          type: 'string',
                        },
                        type: {
                          enum: ['label'],
                          type: 'string',
                        },
                        value: {
                          nullable: true,
                          type: 'string',
                        },
                      },
                      required: ['type', 'value'],
                      type: 'object',
                    },
                    {
                      additionalProperties: false,
                      properties: {
                        color: {
                          enum: ['neutral', 'success', 'warning', 'error', 'info', null],
                          nullable: true,
                          type: 'string',
                        },
                        type: {
                          enum: ['date'],
                          type: 'string',
                        },
                        value: {
                          nullable: true,
                          type: 'string',
                        },
                      },
                      required: ['type', 'value'],
                      type: 'object',
                    },
                    {
                      additionalProperties: false,
                      properties: {
                        color: {
                          enum: ['neutral', 'success', 'warning', 'error', 'info', null],
                          nullable: true,
                          type: 'string',
                        },
                        type: {
                          enum: ['number'],
                          type: 'string',
                        },
                        value: {
                          format: 'double',
                          nullable: true,
                          type: 'number',
                        },
                      },
                      required: ['type', 'value'],
                      type: 'object',
                    },
                    {
                      additionalProperties: false,
                      properties: {
                        color: {
                          enum: ['neutral', 'success', 'warning', 'error', 'info', null],
                          nullable: true,
                          type: 'string',
                        },
                        type: {
                          enum: ['score'],
                          type: 'string',
                        },
                        value: {
                          format: 'double',
                          nullable: true,
                          type: 'number',
                        },
                      },
                      required: ['type', 'value'],
                      type: 'object',
                    },
                    {
                      additionalProperties: false,
                      properties: {
                        color: {
                          enum: ['neutral', 'success', 'warning', 'error', 'info', null],
                          nullable: true,
                          type: 'string',
                        },
                        type: {
                          enum: ['percentage'],
                          type: 'string',
                        },
                        value: {
                          format: 'double',
                          nullable: true,
                          type: 'number',
                        },
                      },
                      required: ['type', 'value'],
                      type: 'object',
                    },
                    {
                      additionalProperties: false,
                      properties: {
                        color: {
                          enum: ['neutral', 'success', 'warning', 'error', 'info', null],
                          nullable: true,
                          type: 'string',
                        },
                        type: {
                          enum: ['boolean'],
                          type: 'string',
                        },
                        value: {
                          nullable: true,
                          type: 'boolean',
                        },
                      },
                      required: ['type', 'value'],
                      type: 'object',
                    },
                    {
                      additionalProperties: false,
                      properties: {
                        color: {
                          enum: ['neutral', 'success', 'warning', 'error', 'info', null],
                          nullable: true,
                          type: 'string',
                        },
                        type: {
                          enum: ['tags'],
                          type: 'string',
                        },
                        value: {
                          items: {
                            type: 'string',
                          },
                          nullable: true,
                          type: 'array',
                        },
                      },
                      required: ['type', 'value'],
                      type: 'object',
                    },
                  ],
                },
              },
              required: ['key', 'value'],
              type: 'object',
            },
            type: 'array',
          },
          id: {
            pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
            type: 'string',
          },
          label: {
            pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
            type: 'string',
          },
        },
        required: ['id', 'label', 'documentIdentifier'],
        type: 'object',
      },
      type: 'array',
    },
    initialSelection: {
      additionalProperties: false,
      nullable: true,
      properties: {
        left: {
          nullable: true,
          pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
          type: 'string',
        },
        right: {
          nullable: true,
          pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
          type: 'string',
        },
      },
      type: 'object',
    },
    note: {
      nullable: true,
      type: 'string',
    },
    results: {
      items: {
        additionalProperties: false,
        properties: {
          key: {
            pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
            type: 'string',
          },
          value: {
            oneOf: [
              {
                additionalProperties: false,
                properties: {
                  color: {
                    enum: ['neutral', 'success', 'warning', 'error', 'info', null],
                    nullable: true,
                    type: 'string',
                  },
                  type: {
                    enum: ['text'],
                    type: 'string',
                  },
                  value: {
                    nullable: true,
                    type: 'string',
                  },
                },
                required: ['type', 'value'],
                type: 'object',
              },
              {
                additionalProperties: false,
                properties: {
                  color: {
                    enum: ['neutral', 'success', 'warning', 'error', 'info', null],
                    nullable: true,
                    type: 'string',
                  },
                  type: {
                    enum: ['label'],
                    type: 'string',
                  },
                  value: {
                    nullable: true,
                    type: 'string',
                  },
                },
                required: ['type', 'value'],
                type: 'object',
              },
              {
                additionalProperties: false,
                properties: {
                  color: {
                    enum: ['neutral', 'success', 'warning', 'error', 'info', null],
                    nullable: true,
                    type: 'string',
                  },
                  type: {
                    enum: ['date'],
                    type: 'string',
                  },
                  value: {
                    nullable: true,
                    type: 'string',
                  },
                },
                required: ['type', 'value'],
                type: 'object',
              },
              {
                additionalProperties: false,
                properties: {
                  color: {
                    enum: ['neutral', 'success', 'warning', 'error', 'info', null],
                    nullable: true,
                    type: 'string',
                  },
                  type: {
                    enum: ['number'],
                    type: 'string',
                  },
                  value: {
                    format: 'double',
                    nullable: true,
                    type: 'number',
                  },
                },
                required: ['type', 'value'],
                type: 'object',
              },
              {
                additionalProperties: false,
                properties: {
                  color: {
                    enum: ['neutral', 'success', 'warning', 'error', 'info', null],
                    nullable: true,
                    type: 'string',
                  },
                  type: {
                    enum: ['score'],
                    type: 'string',
                  },
                  value: {
                    format: 'double',
                    nullable: true,
                    type: 'number',
                  },
                },
                required: ['type', 'value'],
                type: 'object',
              },
              {
                additionalProperties: false,
                properties: {
                  color: {
                    enum: ['neutral', 'success', 'warning', 'error', 'info', null],
                    nullable: true,
                    type: 'string',
                  },
                  type: {
                    enum: ['percentage'],
                    type: 'string',
                  },
                  value: {
                    format: 'double',
                    nullable: true,
                    type: 'number',
                  },
                },
                required: ['type', 'value'],
                type: 'object',
              },
              {
                additionalProperties: false,
                properties: {
                  color: {
                    enum: ['neutral', 'success', 'warning', 'error', 'info', null],
                    nullable: true,
                    type: 'string',
                  },
                  type: {
                    enum: ['boolean'],
                    type: 'string',
                  },
                  value: {
                    nullable: true,
                    type: 'boolean',
                  },
                },
                required: ['type', 'value'],
                type: 'object',
              },
              {
                additionalProperties: false,
                properties: {
                  color: {
                    enum: ['neutral', 'success', 'warning', 'error', 'info', null],
                    nullable: true,
                    type: 'string',
                  },
                  type: {
                    enum: ['tags'],
                    type: 'string',
                  },
                  value: {
                    items: {
                      type: 'string',
                    },
                    nullable: true,
                    type: 'array',
                  },
                },
                required: ['type', 'value'],
                type: 'object',
              },
            ],
          },
        },
        required: ['key', 'value'],
        type: 'object',
      },
      type: 'array',
    },
    title: {
      nullable: true,
      pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
      type: 'string',
    },
  },
  required: ['images'],
  title: 'ImageComparisonBlockConfig',
  type: 'object',
} as const;

export const ImageComparisonColorSchema = {
  enum: ['neutral', 'success', 'warning', 'error', 'info'],
  title: 'ImageComparisonColor',
  type: 'string',
} as const;

export const ImageComparisonImageSchema = {
  additionalProperties: false,
  properties: {
    documentIdentifier: {
      pattern: '^document\\.[A-Za-z0-9_-]+(?:\\.[A-Za-z0-9_-]+)*:[0-9]+$',
      type: 'string',
    },
    fields: {
      items: {
        additionalProperties: false,
        properties: {
          key: {
            pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
            type: 'string',
          },
          value: {
            oneOf: [
              {
                additionalProperties: false,
                properties: {
                  color: {
                    enum: ['neutral', 'success', 'warning', 'error', 'info', null],
                    nullable: true,
                    type: 'string',
                  },
                  type: {
                    enum: ['text'],
                    type: 'string',
                  },
                  value: {
                    nullable: true,
                    type: 'string',
                  },
                },
                required: ['type', 'value'],
                type: 'object',
              },
              {
                additionalProperties: false,
                properties: {
                  color: {
                    enum: ['neutral', 'success', 'warning', 'error', 'info', null],
                    nullable: true,
                    type: 'string',
                  },
                  type: {
                    enum: ['label'],
                    type: 'string',
                  },
                  value: {
                    nullable: true,
                    type: 'string',
                  },
                },
                required: ['type', 'value'],
                type: 'object',
              },
              {
                additionalProperties: false,
                properties: {
                  color: {
                    enum: ['neutral', 'success', 'warning', 'error', 'info', null],
                    nullable: true,
                    type: 'string',
                  },
                  type: {
                    enum: ['date'],
                    type: 'string',
                  },
                  value: {
                    nullable: true,
                    type: 'string',
                  },
                },
                required: ['type', 'value'],
                type: 'object',
              },
              {
                additionalProperties: false,
                properties: {
                  color: {
                    enum: ['neutral', 'success', 'warning', 'error', 'info', null],
                    nullable: true,
                    type: 'string',
                  },
                  type: {
                    enum: ['number'],
                    type: 'string',
                  },
                  value: {
                    format: 'double',
                    nullable: true,
                    type: 'number',
                  },
                },
                required: ['type', 'value'],
                type: 'object',
              },
              {
                additionalProperties: false,
                properties: {
                  color: {
                    enum: ['neutral', 'success', 'warning', 'error', 'info', null],
                    nullable: true,
                    type: 'string',
                  },
                  type: {
                    enum: ['score'],
                    type: 'string',
                  },
                  value: {
                    format: 'double',
                    nullable: true,
                    type: 'number',
                  },
                },
                required: ['type', 'value'],
                type: 'object',
              },
              {
                additionalProperties: false,
                properties: {
                  color: {
                    enum: ['neutral', 'success', 'warning', 'error', 'info', null],
                    nullable: true,
                    type: 'string',
                  },
                  type: {
                    enum: ['percentage'],
                    type: 'string',
                  },
                  value: {
                    format: 'double',
                    nullable: true,
                    type: 'number',
                  },
                },
                required: ['type', 'value'],
                type: 'object',
              },
              {
                additionalProperties: false,
                properties: {
                  color: {
                    enum: ['neutral', 'success', 'warning', 'error', 'info', null],
                    nullable: true,
                    type: 'string',
                  },
                  type: {
                    enum: ['boolean'],
                    type: 'string',
                  },
                  value: {
                    nullable: true,
                    type: 'boolean',
                  },
                },
                required: ['type', 'value'],
                type: 'object',
              },
              {
                additionalProperties: false,
                properties: {
                  color: {
                    enum: ['neutral', 'success', 'warning', 'error', 'info', null],
                    nullable: true,
                    type: 'string',
                  },
                  type: {
                    enum: ['tags'],
                    type: 'string',
                  },
                  value: {
                    items: {
                      type: 'string',
                    },
                    nullable: true,
                    type: 'array',
                  },
                },
                required: ['type', 'value'],
                type: 'object',
              },
            ],
          },
        },
        required: ['key', 'value'],
        type: 'object',
      },
      type: 'array',
    },
    id: {
      pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
      type: 'string',
    },
    label: {
      pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
      type: 'string',
    },
  },
  required: ['id', 'label', 'documentIdentifier'],
  title: 'ImageComparisonImage',
  type: 'object',
} as const;

export const ImageComparisonMetricSchema = {
  additionalProperties: false,
  properties: {
    key: {
      pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
      type: 'string',
    },
    value: {
      oneOf: [
        {
          additionalProperties: false,
          properties: {
            color: {
              enum: ['neutral', 'success', 'warning', 'error', 'info', null],
              nullable: true,
              type: 'string',
            },
            type: {
              enum: ['text'],
              type: 'string',
            },
            value: {
              nullable: true,
              type: 'string',
            },
          },
          required: ['type', 'value'],
          type: 'object',
        },
        {
          additionalProperties: false,
          properties: {
            color: {
              enum: ['neutral', 'success', 'warning', 'error', 'info', null],
              nullable: true,
              type: 'string',
            },
            type: {
              enum: ['label'],
              type: 'string',
            },
            value: {
              nullable: true,
              type: 'string',
            },
          },
          required: ['type', 'value'],
          type: 'object',
        },
        {
          additionalProperties: false,
          properties: {
            color: {
              enum: ['neutral', 'success', 'warning', 'error', 'info', null],
              nullable: true,
              type: 'string',
            },
            type: {
              enum: ['date'],
              type: 'string',
            },
            value: {
              nullable: true,
              type: 'string',
            },
          },
          required: ['type', 'value'],
          type: 'object',
        },
        {
          additionalProperties: false,
          properties: {
            color: {
              enum: ['neutral', 'success', 'warning', 'error', 'info', null],
              nullable: true,
              type: 'string',
            },
            type: {
              enum: ['number'],
              type: 'string',
            },
            value: {
              format: 'double',
              nullable: true,
              type: 'number',
            },
          },
          required: ['type', 'value'],
          type: 'object',
        },
        {
          additionalProperties: false,
          properties: {
            color: {
              enum: ['neutral', 'success', 'warning', 'error', 'info', null],
              nullable: true,
              type: 'string',
            },
            type: {
              enum: ['score'],
              type: 'string',
            },
            value: {
              format: 'double',
              nullable: true,
              type: 'number',
            },
          },
          required: ['type', 'value'],
          type: 'object',
        },
        {
          additionalProperties: false,
          properties: {
            color: {
              enum: ['neutral', 'success', 'warning', 'error', 'info', null],
              nullable: true,
              type: 'string',
            },
            type: {
              enum: ['percentage'],
              type: 'string',
            },
            value: {
              format: 'double',
              nullable: true,
              type: 'number',
            },
          },
          required: ['type', 'value'],
          type: 'object',
        },
        {
          additionalProperties: false,
          properties: {
            color: {
              enum: ['neutral', 'success', 'warning', 'error', 'info', null],
              nullable: true,
              type: 'string',
            },
            type: {
              enum: ['boolean'],
              type: 'string',
            },
            value: {
              nullable: true,
              type: 'boolean',
            },
          },
          required: ['type', 'value'],
          type: 'object',
        },
        {
          additionalProperties: false,
          properties: {
            color: {
              enum: ['neutral', 'success', 'warning', 'error', 'info', null],
              nullable: true,
              type: 'string',
            },
            type: {
              enum: ['tags'],
              type: 'string',
            },
            value: {
              items: {
                type: 'string',
              },
              nullable: true,
              type: 'array',
            },
          },
          required: ['type', 'value'],
          type: 'object',
        },
      ],
    },
  },
  required: ['key', 'value'],
  title: 'ImageComparisonMetric',
  type: 'object',
} as const;

export const ImageComparisonSelectionSchema = {
  additionalProperties: false,
  properties: {
    left: {
      nullable: true,
      pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
      type: 'string',
    },
    right: {
      nullable: true,
      pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
      type: 'string',
    },
  },
  title: 'ImageComparisonSelection',
  type: 'object',
} as const;

export const ImageComparisonValueSchema = {
  oneOf: [
    {
      additionalProperties: false,
      properties: {
        color: {
          enum: ['neutral', 'success', 'warning', 'error', 'info', null],
          nullable: true,
          type: 'string',
        },
        type: {
          enum: ['text'],
          type: 'string',
        },
        value: {
          nullable: true,
          type: 'string',
        },
      },
      required: ['type', 'value'],
      type: 'object',
    },
    {
      additionalProperties: false,
      properties: {
        color: {
          enum: ['neutral', 'success', 'warning', 'error', 'info', null],
          nullable: true,
          type: 'string',
        },
        type: {
          enum: ['label'],
          type: 'string',
        },
        value: {
          nullable: true,
          type: 'string',
        },
      },
      required: ['type', 'value'],
      type: 'object',
    },
    {
      additionalProperties: false,
      properties: {
        color: {
          enum: ['neutral', 'success', 'warning', 'error', 'info', null],
          nullable: true,
          type: 'string',
        },
        type: {
          enum: ['date'],
          type: 'string',
        },
        value: {
          nullable: true,
          type: 'string',
        },
      },
      required: ['type', 'value'],
      type: 'object',
    },
    {
      additionalProperties: false,
      properties: {
        color: {
          enum: ['neutral', 'success', 'warning', 'error', 'info', null],
          nullable: true,
          type: 'string',
        },
        type: {
          enum: ['number'],
          type: 'string',
        },
        value: {
          format: 'double',
          nullable: true,
          type: 'number',
        },
      },
      required: ['type', 'value'],
      type: 'object',
    },
    {
      additionalProperties: false,
      properties: {
        color: {
          enum: ['neutral', 'success', 'warning', 'error', 'info', null],
          nullable: true,
          type: 'string',
        },
        type: {
          enum: ['score'],
          type: 'string',
        },
        value: {
          format: 'double',
          nullable: true,
          type: 'number',
        },
      },
      required: ['type', 'value'],
      type: 'object',
    },
    {
      additionalProperties: false,
      properties: {
        color: {
          enum: ['neutral', 'success', 'warning', 'error', 'info', null],
          nullable: true,
          type: 'string',
        },
        type: {
          enum: ['percentage'],
          type: 'string',
        },
        value: {
          format: 'double',
          nullable: true,
          type: 'number',
        },
      },
      required: ['type', 'value'],
      type: 'object',
    },
    {
      additionalProperties: false,
      properties: {
        color: {
          enum: ['neutral', 'success', 'warning', 'error', 'info', null],
          nullable: true,
          type: 'string',
        },
        type: {
          enum: ['boolean'],
          type: 'string',
        },
        value: {
          nullable: true,
          type: 'boolean',
        },
      },
      required: ['type', 'value'],
      type: 'object',
    },
    {
      additionalProperties: false,
      properties: {
        color: {
          enum: ['neutral', 'success', 'warning', 'error', 'info', null],
          nullable: true,
          type: 'string',
        },
        type: {
          enum: ['tags'],
          type: 'string',
        },
        value: {
          items: {
            type: 'string',
          },
          nullable: true,
          type: 'array',
        },
      },
      required: ['type', 'value'],
      type: 'object',
    },
  ],
  title: 'ImageComparisonValue',
} as const;

export const InstructionBlockKindSchema = {
  enum: ['checklist', 'procedure'],
  title: 'InstructionBlockKind',
  type: 'string',
} as const;

export const InstructionChecklistBlockConfigSchema = {
  additionalProperties: false,
  properties: {
    items: {
      items: {
        not: {
          pattern: '[\\n\\r\\u000b\\u000c\\u0085\\u2028\\u2029]',
          type: 'string',
        },
        pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
        type: 'string',
      },
      type: 'array',
    },
    title: {
      not: {
        pattern: '[\\n\\r\\u000b\\u000c\\u0085\\u2028\\u2029]',
        type: 'string',
      },
      nullable: true,
      pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
      type: 'string',
    },
  },
  required: ['items'],
  title: 'InstructionChecklistBlockConfig',
  type: 'object',
} as const;

export const InstructionProcedureBlockConfigSchema = {
  additionalProperties: false,
  properties: {
    steps: {
      items: {
        not: {
          pattern: '[\\n\\r\\u000b\\u000c\\u0085\\u2028\\u2029]',
          type: 'string',
        },
        pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
        type: 'string',
      },
      type: 'array',
    },
    title: {
      not: {
        pattern: '[\\n\\r\\u000b\\u000c\\u0085\\u2028\\u2029]',
        type: 'string',
      },
      nullable: true,
      pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
      type: 'string',
    },
  },
  required: ['steps'],
  title: 'InstructionProcedureBlockConfig',
  type: 'object',
} as const;
